<div>[{{ note.createdAt | date: 'MM/dd/yyyy'}} {{ note.username }}] <span [innerHtml]="note.safeHtmlContent | safeHtml"></span></div>